import { Injectable } from '@angular/core';
import { ICartDataProvider } from '../../../models/util/cartDataProvider';
import { Cart } from '../../../models/cart';
import { BrowserStorage } from '../../../models/browserStorage';
import { Product } from '../../../models/product';
import { isNoEmptyArray, snakeToCamelCase } from '@pineapplelab/util';
import firebase from "firebase/compat/app";
@Injectable({
	providedIn: 'root'
})
export class GuestCartProviderService implements ICartDataProvider {

	private readonly CART_STORAGE_KEY = 'cart';

	get(): Cart {
		const cart = BrowserStorage.get(this.CART_STORAGE_KEY);
		if (!cart) {
			return null;
		}

		const cartJson = new Cart(JSON.parse(cart));
		cartJson.items = cartJson.items.map((item: object) => new Product(item));
		this.parseAllTimestampFields(cartJson);
		return cartJson;
	}

	save(cart: Cart): void {
		if (!(cart instanceof Cart)) {
			return;
		}
		cart.items = cart.items.map(product => (product && (product instanceof Product)) ? product.toJson() : product);
		const json = cart.toJson();
		this.parseAllTimestampFields(json);
		BrowserStorage.set(this.CART_STORAGE_KEY, json);
	}

	clear(): void {
		if (!BrowserStorage.get(this.CART_STORAGE_KEY)) {
			return;
		}
		BrowserStorage.delete(this.CART_STORAGE_KEY);
	}

	private parseAllTimestampFields(cart: Cart | any): void {
		let timestampFields = ['created_at', 'updated_at'];

		if (cart instanceof Cart) {
			timestampFields = timestampFields.map(field => snakeToCamelCase(field));
		}

		this.parseTimestampField(cart, timestampFields);
		(cart?.items || []).forEach((element: any) => this.parseTimestampField(element, timestampFields));
	}

	private parseTimestampField(model: any, fields: string[]): void {
		if (!model || !fields || !isNoEmptyArray(fields)) {
			return;
		}

		fields.forEach(field => {
			if (!model[field]) {
				return;
			}
			if (!('seconds' in model[field]) && !('nanoseconds' in model[field])) {
				model[field] = null;
				return;
			}

			model[field] = new firebase.firestore.Timestamp(model[field]?.seconds, model[field]?.nanoseconds);
		})
	}

}
